import styled from "styled-components";

export const Container = styled.div`
  table tr td {
    padding: 5px 5px !important;
  }

  table tr td span {
    font-family: 'Edu AU VIC WA NT Hand', sans-serif !important;
    font-size: 14px;
    font-weight: bold;
  }

  
  .qv-object-title-text {
    display: none;
  }

  /* table tr td:not(:first-child) {
    font-size: 11px !important;
    padding-right: 5px !important;
  } */
`